export default "__VITE_ASSET__DAljZhA8__"